import { render } from "./korea.vue?vue&type=template&id=b5783ab0&scoped=true"
import script from "./korea.vue?vue&type=script&lang=js"
export * from "./korea.vue?vue&type=script&lang=js"

import "./korea.vue?vue&type=style&index=0&id=b5783ab0&lang=scss&scoped=true"
import "./korea.vue?vue&type=style&index=1&id=b5783ab0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b5783ab0"

export default script